import { getUserType } from "utils/CommonFunctions";
import { hasTemplatePlansAccess } from "utils/StoreUtils";
import { userTypes } from "utils/Types";

export const checkCopyActionAccess = () => {
  return hasTemplatePlansAccess() || getUserType() === userTypes.HOTEL_USER;
};
